/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftSwap } from './ShiftSwap';
import {
    ShiftSwapFromJSON,
    ShiftSwapFromJSONTyped,
    ShiftSwapToJSON,
    ShiftSwapToJSONTyped,
} from './ShiftSwap';

/**
 * 
 * @export
 * @interface ShowShiftSwapResponse
 */
export interface ShowShiftSwapResponse {
    /**
     * 
     * @type {ShiftSwap}
     * @memberof ShowShiftSwapResponse
     */
    data: ShiftSwap;
}

/**
 * Check if a given object implements the ShowShiftSwapResponse interface.
 */
export function instanceOfShowShiftSwapResponse(value: object): value is ShowShiftSwapResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowShiftSwapResponseFromJSON(json: any): ShowShiftSwapResponse {
    return ShowShiftSwapResponseFromJSONTyped(json, false);
}

export function ShowShiftSwapResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowShiftSwapResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ShiftSwapFromJSON(json['data']),
    };
}

  export function ShowShiftSwapResponseToJSON(json: any): ShowShiftSwapResponse {
      return ShowShiftSwapResponseToJSONTyped(json, false);
  }

  export function ShowShiftSwapResponseToJSONTyped(value?: ShowShiftSwapResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ShiftSwapToJSON(value['data']),
    };
}

